import Login from "./componenets/Auth/Login";

function App() {
  return (
      <Login/>
  );
}

export default App;
